module.exports = __webpack_public_path__ + "img/icon-lightbulb-light-blue-old.15bfbe80.svg";